import { render, staticRenderFns } from "./UserSelection.vue?vue&type=template&id=cbf30794&scoped=true&"
import script from "./UserSelection.vue?vue&type=script&lang=js&"
export * from "./UserSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf30794",
  null
  
)

export default component.exports